import * as z from "zod";

export const MarketplaceFulfillmentDelayCriteriaSchema = z.object({
  delayDays: z.number().int().min(1),
});
export type MarketplaceFulfillmentDelayCriteria = z.infer<
  typeof MarketplaceFulfillmentDelayCriteriaSchema
>;

export function getFulfillmentNotificationReleaseHour(
  configuredReleaseHour: number | null | undefined,
): number {
  return typeof configuredReleaseHour === "number" &&
    Number.isInteger(configuredReleaseHour) &&
    configuredReleaseHour >= 0 &&
    configuredReleaseHour <= 23
    ? configuredReleaseHour
    : 9;
}

export interface MarketplaceFulfillmentSettings {
  notifyMarketplace?: boolean | null;
  fulfillmentDate?: Date | null;
}

export type ResolvedMarketplaceFulfillmentSettings =
  | { notifyMarketplace: false; fulfillmentDate?: never }
  | { notifyMarketplace: true; fulfillmentDate?: Date };

export function resolveMarketplaceFulfillmentSettings({
  notifyMarketplace,
  fulfillmentDate,
}: MarketplaceFulfillmentSettings): ResolvedMarketplaceFulfillmentSettings {
  if (notifyMarketplace === false) {
    return { notifyMarketplace: false };
  }
  return {
    notifyMarketplace: true,
    fulfillmentDate: fulfillmentDate ?? undefined,
  };
}

export function getFulfillmentDateForDelay({
  criteria,
  now,
  releaseHour,
  timeZone,
}: {
  criteria: MarketplaceFulfillmentDelayCriteria;
  now: Date;
  releaseHour: number;
  timeZone: string;
}): Date {
  const fulfillmentDate = Temporal.Instant.fromEpochMilliseconds(now.getTime())
    .toZonedDateTimeISO(timeZone)
    .add({ days: criteria.delayDays })
    .with({
      hour: releaseHour,
      minute: 0,
      second: 0,
      millisecond: 0,
      microsecond: 0,
      nanosecond: 0,
    });

  return new Date(fulfillmentDate.epochMilliseconds);
}
